module.exports = __webpack_public_path__ + "static/footer_bg.db5ad9e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/footer_bg.png
// module id = 449
// module chunks = 104033720589488